import { GetOrdersOptions } from './get-orders'

export const orderKeys = {
  all: ['orders'] as const,
  lists: () => [...orderKeys.all, 'list'] as const,
  list: (opts: GetOrdersOptions) => [...orderKeys.lists(), { ...opts }] as const,
  details: () => [...orderKeys.all, 'detail'] as const,
  detail: (oid: string) => [...orderKeys.details(), oid] as const,
  allQuestions: (oid: string) => [...orderKeys.detail(oid), 'questions'] as const,
  allMessages: (oid: string) => [...orderKeys.detail(oid), 'messages'] as const,
  allActivity: (oid: string) => [...orderKeys.detail(oid), 'activity'] as const,
  messagesCount: ({ oid, uid }: { oid: string; uid: string }) => [...orderKeys.allMessages(oid), 'count', uid],
}
